import {
  customAxios
} from "../chunk-RSSSV4W5.mjs";

// src/react-query/program.ts
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
var getProgramsForTenant = (params, options, signal) => {
  return customAxios(
    { url: `/api/program`, method: "GET", params, signal },
    options
  );
};
var getGetProgramsForTenantQueryKey = (params) => {
  return [`/api/program`, ...params ? [params] : []];
};
var getGetProgramsForTenantQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetProgramsForTenantQueryKey(params);
  const queryFn = ({ signal }) => getProgramsForTenant(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetProgramsForTenant(params, options) {
  const queryOptions = getGetProgramsForTenantQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetProgramsForTenantSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetProgramsForTenantQueryKey(params);
  const queryFn = ({ signal }) => getProgramsForTenant(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetProgramsForTenantSuspense(params, options) {
  const queryOptions = getGetProgramsForTenantSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var createProgram = (createProgramBody, options, signal) => {
  return customAxios(
    {
      url: `/api/program`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createProgramBody,
      signal
    },
    options
  );
};
var getCreateProgramMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return createProgram(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useCreateProgram = (options) => {
  const mutationOptions = getCreateProgramMutationOptions(options);
  return useMutation(mutationOptions);
};
var getProgramByID = (programID, options, signal) => {
  return customAxios(
    { url: `/api/program/${programID}`, method: "GET", signal },
    options
  );
};
var getGetProgramByIDQueryKey = (programID) => {
  return [`/api/program/${programID}`];
};
var getGetProgramByIDQueryOptions = (programID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetProgramByIDQueryKey(programID);
  const queryFn = ({
    signal
  }) => getProgramByID(programID, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!programID,
    ...queryOptions
  };
};
function useGetProgramByID(programID, options) {
  const queryOptions = getGetProgramByIDQueryOptions(programID, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetProgramByIDSuspenseQueryOptions = (programID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetProgramByIDQueryKey(programID);
  const queryFn = ({
    signal
  }) => getProgramByID(programID, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetProgramByIDSuspense(programID, options) {
  const queryOptions = getGetProgramByIDSuspenseQueryOptions(
    programID,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getPaymentProductsForProgram = (programID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/payment-product`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetPaymentProductsForProgramQueryKey = (programID, params) => {
  return [
    `/api/program/${programID}/payment-product`,
    ...params ? [params] : []
  ];
};
var getGetPaymentProductsForProgramQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductsForProgramQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductsForProgram(programID, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!programID,
    ...queryOptions
  };
};
function useGetPaymentProductsForProgram(programID, params, options) {
  const queryOptions = getGetPaymentProductsForProgramQueryOptions(
    programID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPaymentProductsForProgramSuspenseQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductsForProgramQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductsForProgram(programID, params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPaymentProductsForProgramSuspense(programID, params, options) {
  const queryOptions = getGetPaymentProductsForProgramSuspenseQueryOptions(
    programID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getPaymentProductByID = (programID, paymentProductID, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/payment-product/${paymentProductID}`,
      method: "GET",
      signal
    },
    options
  );
};
var getGetPaymentProductByIDQueryKey = (programID, paymentProductID) => {
  return [
    `/api/program/${programID}/payment-product/${paymentProductID}`
  ];
};
var getGetPaymentProductByIDQueryOptions = (programID, paymentProductID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductByIDQueryKey(programID, paymentProductID);
  const queryFn = ({ signal }) => getPaymentProductByID(programID, paymentProductID, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!(programID && paymentProductID),
    ...queryOptions
  };
};
function useGetPaymentProductByID(programID, paymentProductID, options) {
  const queryOptions = getGetPaymentProductByIDQueryOptions(
    programID,
    paymentProductID,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPaymentProductByIDSuspenseQueryOptions = (programID, paymentProductID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductByIDQueryKey(programID, paymentProductID);
  const queryFn = ({ signal }) => getPaymentProductByID(programID, paymentProductID, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPaymentProductByIDSuspense(programID, paymentProductID, options) {
  const queryOptions = getGetPaymentProductByIDSuspenseQueryOptions(
    programID,
    paymentProductID,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getPaymentProductAggregation = (programID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/payment-product/aggregation`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetPaymentProductAggregationQueryKey = (programID, params) => {
  return [
    `/api/program/${programID}/payment-product/aggregation`,
    ...params ? [params] : []
  ];
};
var getGetPaymentProductAggregationQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductAggregationQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductAggregation(programID, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!programID,
    ...queryOptions
  };
};
function useGetPaymentProductAggregation(programID, params, options) {
  const queryOptions = getGetPaymentProductAggregationQueryOptions(
    programID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPaymentProductAggregationSuspenseQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductAggregationQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductAggregation(programID, params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPaymentProductAggregationSuspense(programID, params, options) {
  const queryOptions = getGetPaymentProductAggregationSuspenseQueryOptions(
    programID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getPaymentProductConfiguration = (programID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/payment-product-configuration`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetPaymentProductConfigurationQueryKey = (programID, params) => {
  return [
    `/api/program/${programID}/payment-product-configuration`,
    ...params ? [params] : []
  ];
};
var getGetPaymentProductConfigurationQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductConfigurationQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductConfiguration(programID, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!programID,
    ...queryOptions
  };
};
function useGetPaymentProductConfiguration(programID, params, options) {
  const queryOptions = getGetPaymentProductConfigurationQueryOptions(
    programID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPaymentProductConfigurationSuspenseQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductConfigurationQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductConfiguration(programID, params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPaymentProductConfigurationSuspense(programID, params, options) {
  const queryOptions = getGetPaymentProductConfigurationSuspenseQueryOptions(
    programID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var listPaymentProductEnrollment = (params, options, signal) => {
  return customAxios(
    { url: `/api/payment-product-enrollment`, method: "GET", params, signal },
    options
  );
};
var getListPaymentProductEnrollmentQueryKey = (params) => {
  return [
    `/api/payment-product-enrollment`,
    ...params ? [params] : []
  ];
};
var getListPaymentProductEnrollmentQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListPaymentProductEnrollmentQueryKey(params);
  const queryFn = ({ signal }) => listPaymentProductEnrollment(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListPaymentProductEnrollment(params, options) {
  const queryOptions = getListPaymentProductEnrollmentQueryOptions(
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListPaymentProductEnrollmentSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListPaymentProductEnrollmentQueryKey(params);
  const queryFn = ({ signal }) => listPaymentProductEnrollment(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListPaymentProductEnrollmentSuspense(params, options) {
  const queryOptions = getListPaymentProductEnrollmentSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var createPaymentProductEnrollment = (createPaymentProductEnrollmentRequestBody, options, signal) => {
  return customAxios(
    {
      url: `/api/payment-product-enrollment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentProductEnrollmentRequestBody,
      signal
    },
    options
  );
};
var getCreatePaymentProductEnrollmentMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return createPaymentProductEnrollment(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useCreatePaymentProductEnrollment = (options) => {
  const mutationOptions = getCreatePaymentProductEnrollmentMutationOptions(options);
  return useMutation(mutationOptions);
};
var patchPaymentProductEnrollment = (enrollmentID, patchPaymentProductEnrollmentRequestBody, options) => {
  return customAxios(
    {
      url: `/api/payment-product-enrollment/${enrollmentID}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: patchPaymentProductEnrollmentRequestBody
    },
    options
  );
};
var getPatchPaymentProductEnrollmentMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { enrollmentID, data } = props ?? {};
    return patchPaymentProductEnrollment(enrollmentID, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var usePatchPaymentProductEnrollment = (options) => {
  const mutationOptions = getPatchPaymentProductEnrollmentMutationOptions(options);
  return useMutation(mutationOptions);
};
var deletePaymentProductEnrollment = (enrollmentID, options) => {
  return customAxios(
    {
      url: `/api/payment-product-enrollment/${enrollmentID}`,
      method: "DELETE"
    },
    options
  );
};
var getDeletePaymentProductEnrollmentMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { enrollmentID } = props ?? {};
    return deletePaymentProductEnrollment(enrollmentID, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useDeletePaymentProductEnrollment = (options) => {
  const mutationOptions = getDeletePaymentProductEnrollmentMutationOptions(options);
  return useMutation(mutationOptions);
};
var getPaymentProductsForMerchantAndProgram = (programID, merchantID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/merchant/${merchantID}/payment-products`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetPaymentProductsForMerchantAndProgramQueryKey = (programID, merchantID, params) => {
  return [
    `/api/program/${programID}/merchant/${merchantID}/payment-products`,
    ...params ? [params] : []
  ];
};
var getGetPaymentProductsForMerchantAndProgramQueryOptions = (programID, merchantID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductsForMerchantAndProgramQueryKey(
    programID,
    merchantID,
    params
  );
  const queryFn = ({ signal }) => getPaymentProductsForMerchantAndProgram(
    programID,
    merchantID,
    params,
    requestOptions,
    signal
  );
  return {
    queryKey,
    queryFn,
    enabled: !!(programID && merchantID),
    ...queryOptions
  };
};
function useGetPaymentProductsForMerchantAndProgram(programID, merchantID, params, options) {
  const queryOptions = getGetPaymentProductsForMerchantAndProgramQueryOptions(
    programID,
    merchantID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPaymentProductsForMerchantAndProgramSuspenseQueryOptions = (programID, merchantID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductsForMerchantAndProgramQueryKey(
    programID,
    merchantID,
    params
  );
  const queryFn = ({ signal }) => getPaymentProductsForMerchantAndProgram(
    programID,
    merchantID,
    params,
    requestOptions,
    signal
  );
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPaymentProductsForMerchantAndProgramSuspense(programID, merchantID, params, options) {
  const queryOptions = getGetPaymentProductsForMerchantAndProgramSuspenseQueryOptions(
    programID,
    merchantID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var listEnrollmentSummaries = (merchantID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/payment-product-comparison/summary/${merchantID}`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getListEnrollmentSummariesQueryKey = (merchantID, params) => {
  return [
    `/api/payment-product-comparison/summary/${merchantID}`,
    ...params ? [params] : []
  ];
};
var getListEnrollmentSummariesQueryOptions = (merchantID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListEnrollmentSummariesQueryKey(merchantID, params);
  const queryFn = ({ signal }) => listEnrollmentSummaries(merchantID, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!merchantID,
    ...queryOptions
  };
};
function useListEnrollmentSummaries(merchantID, params, options) {
  const queryOptions = getListEnrollmentSummariesQueryOptions(
    merchantID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListEnrollmentSummariesSuspenseQueryOptions = (merchantID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListEnrollmentSummariesQueryKey(merchantID, params);
  const queryFn = ({ signal }) => listEnrollmentSummaries(merchantID, params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListEnrollmentSummariesSuspense(merchantID, params, options) {
  const queryOptions = getListEnrollmentSummariesSuspenseQueryOptions(
    merchantID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var listMerchantPaymentProductEnrollment = (params, options, signal) => {
  return customAxios(
    { url: `/api/payment-product-comparison`, method: "GET", params, signal },
    options
  );
};
var getListMerchantPaymentProductEnrollmentQueryKey = (params) => {
  return [
    `/api/payment-product-comparison`,
    ...params ? [params] : []
  ];
};
var getListMerchantPaymentProductEnrollmentQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListMerchantPaymentProductEnrollmentQueryKey(params);
  const queryFn = ({ signal }) => listMerchantPaymentProductEnrollment(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListMerchantPaymentProductEnrollment(params, options) {
  const queryOptions = getListMerchantPaymentProductEnrollmentQueryOptions(
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListMerchantPaymentProductEnrollmentSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListMerchantPaymentProductEnrollmentQueryKey(params);
  const queryFn = ({ signal }) => listMerchantPaymentProductEnrollment(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListMerchantPaymentProductEnrollmentSuspense(params, options) {
  const queryOptions = getListMerchantPaymentProductEnrollmentSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getMerchantProgramValues = (programID, merchantID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/merchant/${merchantID}/values`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetMerchantProgramValuesQueryKey = (programID, merchantID, params) => {
  return [
    `/api/program/${programID}/merchant/${merchantID}/values`,
    ...params ? [params] : []
  ];
};
var getGetMerchantProgramValuesQueryOptions = (programID, merchantID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantProgramValuesQueryKey(programID, merchantID, params);
  const queryFn = ({ signal }) => getMerchantProgramValues(
    programID,
    merchantID,
    params,
    requestOptions,
    signal
  );
  return {
    queryKey,
    queryFn,
    enabled: !!(programID && merchantID),
    ...queryOptions
  };
};
function useGetMerchantProgramValues(programID, merchantID, params, options) {
  const queryOptions = getGetMerchantProgramValuesQueryOptions(
    programID,
    merchantID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetMerchantProgramValuesSuspenseQueryOptions = (programID, merchantID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantProgramValuesQueryKey(programID, merchantID, params);
  const queryFn = ({ signal }) => getMerchantProgramValues(
    programID,
    merchantID,
    params,
    requestOptions,
    signal
  );
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantProgramValuesSuspense(programID, merchantID, params, options) {
  const queryOptions = getGetMerchantProgramValuesSuspenseQueryOptions(
    programID,
    merchantID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var updateMerchantProgramValues = (programID, merchantID, updateMerchantProgramValuesBody, options) => {
  return customAxios(
    {
      url: `/api/program/${programID}/merchant/${merchantID}/values`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateMerchantProgramValuesBody
    },
    options
  );
};
var getUpdateMerchantProgramValuesMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { programID, merchantID, data } = props ?? {};
    return updateMerchantProgramValues(
      programID,
      merchantID,
      data,
      requestOptions
    );
  };
  return { mutationFn, ...mutationOptions };
};
var useUpdateMerchantProgramValues = (options) => {
  const mutationOptions = getUpdateMerchantProgramValuesMutationOptions(options);
  return useMutation(mutationOptions);
};
var getPartnerProgramValues = (programID, partnerID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/program/${programID}/partner/${partnerID}/values`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetPartnerProgramValuesQueryKey = (programID, partnerID, params) => {
  return [
    `/api/program/${programID}/partner/${partnerID}/values`,
    ...params ? [params] : []
  ];
};
var getGetPartnerProgramValuesQueryOptions = (programID, partnerID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPartnerProgramValuesQueryKey(programID, partnerID, params);
  const queryFn = ({ signal }) => getPartnerProgramValues(
    programID,
    partnerID,
    params,
    requestOptions,
    signal
  );
  return {
    queryKey,
    queryFn,
    enabled: !!(programID && partnerID),
    ...queryOptions
  };
};
function useGetPartnerProgramValues(programID, partnerID, params, options) {
  const queryOptions = getGetPartnerProgramValuesQueryOptions(
    programID,
    partnerID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPartnerProgramValuesSuspenseQueryOptions = (programID, partnerID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPartnerProgramValuesQueryKey(programID, partnerID, params);
  const queryFn = ({ signal }) => getPartnerProgramValues(
    programID,
    partnerID,
    params,
    requestOptions,
    signal
  );
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPartnerProgramValuesSuspense(programID, partnerID, params, options) {
  const queryOptions = getGetPartnerProgramValuesSuspenseQueryOptions(
    programID,
    partnerID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var updateUICustomizations = (programID, merchantID, updateUICustomizationBody, options) => {
  return customAxios(
    {
      url: `/api/program/${programID}/merchant/${merchantID}/customizations`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateUICustomizationBody
    },
    options
  );
};
var getUpdateUICustomizationsMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { programID, merchantID, data } = props ?? {};
    return updateUICustomizations(programID, merchantID, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useUpdateUICustomizations = (options) => {
  const mutationOptions = getUpdateUICustomizationsMutationOptions(options);
  return useMutation(mutationOptions);
};
var getMerchantEnrollment = (params, options, signal) => {
  return customAxios(
    { url: `/api/merchant-enrollment`, method: "GET", params, signal },
    options
  );
};
var getGetMerchantEnrollmentQueryKey = (params) => {
  return [`/api/merchant-enrollment`, ...params ? [params] : []];
};
var getGetMerchantEnrollmentQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantEnrollmentQueryKey(params);
  const queryFn = ({ signal }) => getMerchantEnrollment(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantEnrollment(params, options) {
  const queryOptions = getGetMerchantEnrollmentQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetMerchantEnrollmentSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantEnrollmentQueryKey(params);
  const queryFn = ({ signal }) => getMerchantEnrollment(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantEnrollmentSuspense(params, options) {
  const queryOptions = getGetMerchantEnrollmentSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getPaymentProductsFilter = (programID, params, options, signal) => {
  return customAxios(
    {
      url: `/api/merchant-enrollment/program/${programID}/payment-product`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetPaymentProductsFilterQueryKey = (programID, params) => {
  return [
    `/api/merchant-enrollment/program/${programID}/payment-product`,
    ...params ? [params] : []
  ];
};
var getGetPaymentProductsFilterQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductsFilterQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductsFilter(programID, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!programID,
    ...queryOptions
  };
};
function useGetPaymentProductsFilter(programID, params, options) {
  const queryOptions = getGetPaymentProductsFilterQueryOptions(
    programID,
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPaymentProductsFilterSuspenseQueryOptions = (programID, params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPaymentProductsFilterQueryKey(programID, params);
  const queryFn = ({ signal }) => getPaymentProductsFilter(programID, params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPaymentProductsFilterSuspense(programID, params, options) {
  const queryOptions = getGetPaymentProductsFilterSuspenseQueryOptions(
    programID,
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var listExperiences = (params, options, signal) => {
  return customAxios(
    { url: `/api/experience-keys`, method: "GET", params, signal },
    options
  );
};
var getListExperiencesQueryKey = (params) => {
  return [`/api/experience-keys`, ...params ? [params] : []];
};
var getListExperiencesQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListExperiencesQueryKey(params);
  const queryFn = ({
    signal
  }) => listExperiences(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListExperiences(params, options) {
  const queryOptions = getListExperiencesQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListExperiencesSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListExperiencesQueryKey(params);
  const queryFn = ({
    signal
  }) => listExperiences(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListExperiencesSuspense(params, options) {
  const queryOptions = getListExperiencesSuspenseQueryOptions(params, options);
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var listMerchantExperience = (params, options, signal) => {
  return customAxios(
    { url: `/api/merchant-experience`, method: "GET", params, signal },
    options
  );
};
var getListMerchantExperienceQueryKey = (params) => {
  return [`/api/merchant-experience`, ...params ? [params] : []];
};
var getListMerchantExperienceQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListMerchantExperienceQueryKey(params);
  const queryFn = ({ signal }) => listMerchantExperience(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListMerchantExperience(params, options) {
  const queryOptions = getListMerchantExperienceQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListMerchantExperienceSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListMerchantExperienceQueryKey(params);
  const queryFn = ({ signal }) => listMerchantExperience(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListMerchantExperienceSuspense(params, options) {
  const queryOptions = getListMerchantExperienceSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getMerchantExperienceByID = (experienceID, options, signal) => {
  return customAxios(
    { url: `/api/merchant-experience/${experienceID}`, method: "GET", signal },
    options
  );
};
var getGetMerchantExperienceByIDQueryKey = (experienceID) => {
  return [`/api/merchant-experience/${experienceID}`];
};
var getGetMerchantExperienceByIDQueryOptions = (experienceID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantExperienceByIDQueryKey(experienceID);
  const queryFn = ({ signal }) => getMerchantExperienceByID(experienceID, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!experienceID,
    ...queryOptions
  };
};
function useGetMerchantExperienceByID(experienceID, options) {
  const queryOptions = getGetMerchantExperienceByIDQueryOptions(
    experienceID,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetMerchantExperienceByIDSuspenseQueryOptions = (experienceID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantExperienceByIDQueryKey(experienceID);
  const queryFn = ({ signal }) => getMerchantExperienceByID(experienceID, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantExperienceByIDSuspense(experienceID, options) {
  const queryOptions = getGetMerchantExperienceByIDSuspenseQueryOptions(
    experienceID,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var deleteMerchantExperience = (experienceID, options) => {
  return customAxios(
    { url: `/api/merchant-experience/${experienceID}`, method: "DELETE" },
    options
  );
};
var getDeleteMerchantExperienceMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { experienceID } = props ?? {};
    return deleteMerchantExperience(experienceID, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useDeleteMerchantExperience = (options) => {
  const mutationOptions = getDeleteMerchantExperienceMutationOptions(options);
  return useMutation(mutationOptions);
};
var getMerchantProgramParticipation = (params, options, signal) => {
  return customAxios(
    {
      url: `/api/merchant-program-participation`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getGetMerchantProgramParticipationQueryKey = (params) => {
  return [
    `/api/merchant-program-participation`,
    ...params ? [params] : []
  ];
};
var getGetMerchantProgramParticipationQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantProgramParticipationQueryKey(params);
  const queryFn = ({ signal }) => getMerchantProgramParticipation(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantProgramParticipation(params, options) {
  const queryOptions = getGetMerchantProgramParticipationQueryOptions(
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetMerchantProgramParticipationSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantProgramParticipationQueryKey(params);
  const queryFn = ({ signal }) => getMerchantProgramParticipation(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantProgramParticipationSuspense(params, options) {
  const queryOptions = getGetMerchantProgramParticipationSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getMerchantProgramParticipationByID = (participationID, options, signal) => {
  return customAxios(
    {
      url: `/api/merchant-program-participation/${participationID}`,
      method: "GET",
      signal
    },
    options
  );
};
var getGetMerchantProgramParticipationByIDQueryKey = (participationID) => {
  return [`/api/merchant-program-participation/${participationID}`];
};
var getGetMerchantProgramParticipationByIDQueryOptions = (participationID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantProgramParticipationByIDQueryKey(participationID);
  const queryFn = ({ signal }) => getMerchantProgramParticipationByID(
    participationID,
    requestOptions,
    signal
  );
  return {
    queryKey,
    queryFn,
    enabled: !!participationID,
    ...queryOptions
  };
};
function useGetMerchantProgramParticipationByID(participationID, options) {
  const queryOptions = getGetMerchantProgramParticipationByIDQueryOptions(
    participationID,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetMerchantProgramParticipationByIDSuspenseQueryOptions = (participationID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchantProgramParticipationByIDQueryKey(participationID);
  const queryFn = ({ signal }) => getMerchantProgramParticipationByID(
    participationID,
    requestOptions,
    signal
  );
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMerchantProgramParticipationByIDSuspense(participationID, options) {
  const queryOptions = getGetMerchantProgramParticipationByIDSuspenseQueryOptions(
    participationID,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var deleteMerchantProgramParticipationByID = (participationID, options) => {
  return customAxios(
    {
      url: `/api/merchant-program-participation/${participationID}`,
      method: "DELETE"
    },
    options
  );
};
var getDeleteMerchantProgramParticipationByIDMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { participationID } = props ?? {};
    return deleteMerchantProgramParticipationByID(
      participationID,
      requestOptions
    );
  };
  return { mutationFn, ...mutationOptions };
};
var useDeleteMerchantProgramParticipationByID = (options) => {
  const mutationOptions = getDeleteMerchantProgramParticipationByIDMutationOptions(options);
  return useMutation(mutationOptions);
};
var getPartnerProgramParticipation = (participationID, options, signal) => {
  return customAxios(
    {
      url: `/api/partner-program-participation/${participationID}`,
      method: "GET",
      signal
    },
    options
  );
};
var getGetPartnerProgramParticipationQueryKey = (participationID) => {
  return [`/api/partner-program-participation/${participationID}`];
};
var getGetPartnerProgramParticipationQueryOptions = (participationID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPartnerProgramParticipationQueryKey(participationID);
  const queryFn = ({ signal }) => getPartnerProgramParticipation(participationID, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!participationID,
    ...queryOptions
  };
};
function useGetPartnerProgramParticipation(participationID, options) {
  const queryOptions = getGetPartnerProgramParticipationQueryOptions(
    participationID,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetPartnerProgramParticipationSuspenseQueryOptions = (participationID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPartnerProgramParticipationQueryKey(participationID);
  const queryFn = ({ signal }) => getPartnerProgramParticipation(participationID, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetPartnerProgramParticipationSuspense(participationID, options) {
  const queryOptions = getGetPartnerProgramParticipationSuspenseQueryOptions(
    participationID,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var deletePartnerProgramParticipation = (participationID, options) => {
  return customAxios(
    {
      url: `/api/partner-program-participation/${participationID}`,
      method: "DELETE"
    },
    options
  );
};
var getDeletePartnerProgramParticipationMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { participationID } = props ?? {};
    return deletePartnerProgramParticipation(participationID, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useDeletePartnerProgramParticipation = (options) => {
  const mutationOptions = getDeletePartnerProgramParticipationMutationOptions(options);
  return useMutation(mutationOptions);
};
var listPartnerProgramParticipation = (params, options, signal) => {
  return customAxios(
    {
      url: `/api/partner-program-participation`,
      method: "GET",
      params,
      signal
    },
    options
  );
};
var getListPartnerProgramParticipationQueryKey = (params) => {
  return [
    `/api/partner-program-participation`,
    ...params ? [params] : []
  ];
};
var getListPartnerProgramParticipationQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListPartnerProgramParticipationQueryKey(params);
  const queryFn = ({ signal }) => listPartnerProgramParticipation(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListPartnerProgramParticipation(params, options) {
  const queryOptions = getListPartnerProgramParticipationQueryOptions(
    params,
    options
  );
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListPartnerProgramParticipationSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListPartnerProgramParticipationQueryKey(params);
  const queryFn = ({ signal }) => listPartnerProgramParticipation(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListPartnerProgramParticipationSuspense(params, options) {
  const queryOptions = getListPartnerProgramParticipationSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var createPartnerProgramParticipation = (createPartnerParticipationBody, options, signal) => {
  return customAxios(
    {
      url: `/api/partner-program-participation`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPartnerParticipationBody,
      signal
    },
    options
  );
};
var getCreatePartnerProgramParticipationMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return createPartnerProgramParticipation(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useCreatePartnerProgramParticipation = (options) => {
  const mutationOptions = getCreatePartnerProgramParticipationMutationOptions(options);
  return useMutation(mutationOptions);
};
var getFundingConfiguration = (params, options, signal) => {
  return customAxios(
    { url: `/api/funding-configuration`, method: "GET", params, signal },
    options
  );
};
var getGetFundingConfigurationQueryKey = (params) => {
  return [`/api/funding-configuration`, ...params ? [params] : []];
};
var getGetFundingConfigurationQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetFundingConfigurationQueryKey(params);
  const queryFn = ({ signal }) => getFundingConfiguration(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetFundingConfiguration(params, options) {
  const queryOptions = getGetFundingConfigurationQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetFundingConfigurationSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetFundingConfigurationQueryKey(params);
  const queryFn = ({ signal }) => getFundingConfiguration(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetFundingConfigurationSuspense(params, options) {
  const queryOptions = getGetFundingConfigurationSuspenseQueryOptions(
    params,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var updateFundingConfiguration = (configurationID, updateFundingConfigurationBody, options) => {
  return customAxios(
    {
      url: `/api/funding-configuration/${configurationID}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateFundingConfigurationBody
    },
    options
  );
};
var getUpdateFundingConfigurationMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { configurationID, data } = props ?? {};
    return updateFundingConfiguration(configurationID, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useUpdateFundingConfiguration = (options) => {
  const mutationOptions = getUpdateFundingConfigurationMutationOptions(options);
  return useMutation(mutationOptions);
};

// src/react-query/program/model/aggregationTerm.ts
var AggregationTerm = {
  TYPE: "TYPE",
  NUMPAYMENTS: "NUMPAYMENTS",
  RATE: "RATE"
};

// src/react-query/program/model/experienceErrorReason.ts
var ExperienceErrorReason = {
  Unauthorized: "Unauthorized",
  Request_Validation: "Request_Validation",
  Not_Found: "Not_Found",
  Internal_Server_Failure: "Internal_Server_Failure",
  Dependency_Unavailable: "Dependency_Unavailable"
};

// src/react-query/program/model/fundingConfigurationScopeType.ts
var FundingConfigurationScopeType = {
  MERCHANT: "MERCHANT",
  LOCATION: "LOCATION",
  PARTNER: "PARTNER"
};

// src/react-query/program/model/getFundingConfigurationScopeTypeEq.ts
var GetFundingConfigurationScopeTypeEq = {
  MERCHANT: "MERCHANT",
  LOCATION: "LOCATION",
  PARTNER: "PARTNER"
};

// src/react-query/program/model/getPaymentProductConfigurationState.ts
var GetPaymentProductConfigurationState = {
  LAPSED: "LAPSED",
  ACTIVE: "ACTIVE",
  SCHEDULED: "SCHEDULED"
};

// src/react-query/program/model/listPaymentProductEnrollmentStateItem.ts
var ListPaymentProductEnrollmentStateItem = {
  LAPSED: "LAPSED",
  ACTIVE: "ACTIVE",
  SCHEDULED: "SCHEDULED"
};

// src/react-query/program/model/merchantProgramParticipationDefaultOTPMethod.ts
var MerchantProgramParticipationDefaultOTPMethod = {
  EMAIL: "EMAIL",
  SMS: "SMS"
};

// src/react-query/program/model/merchantProgramValuesDefaultOTPMethod.ts
var MerchantProgramValuesDefaultOTPMethod = {
  EMAIL: "EMAIL",
  SMS: "SMS"
};

// src/react-query/program/model/programCheckoutMode.ts
var ProgramCheckoutMode = {
  VirtualCard: "VirtualCard",
  PointOfSale: "PointOfSale"
};

// src/react-query/program/model/programErrorReason.ts
var ProgramErrorReason = {
  Unauthorized: "Unauthorized",
  Request_Validation: "Request_Validation",
  Internal_Server_Failure: "Internal_Server_Failure",
  Dependency_Unavailable: "Dependency_Unavailable"
};

// src/react-query/program/model/programV2ResponseCheckoutMode.ts
var ProgramV2ResponseCheckoutMode = {
  VirtualCard: "VirtualCard",
  PointOfSale: "PointOfSale"
};

// src/react-query/program/model/models.openapi3/paymentProductType.ts
var PaymentProductType = {
  INSTALLMENTS: "INSTALLMENTS",
  SPLITPAY: "SPLITPAY",
  DEBT_CONSOLIDATION: "DEBT_CONSOLIDATION",
  PERSONAL_LOAN: "PERSONAL_LOAN"
};
export {
  AggregationTerm,
  ExperienceErrorReason,
  FundingConfigurationScopeType,
  GetFundingConfigurationScopeTypeEq,
  GetPaymentProductConfigurationState,
  ListPaymentProductEnrollmentStateItem,
  MerchantProgramParticipationDefaultOTPMethod,
  MerchantProgramValuesDefaultOTPMethod,
  PaymentProductType,
  ProgramCheckoutMode,
  ProgramErrorReason,
  ProgramV2ResponseCheckoutMode,
  createPartnerProgramParticipation,
  createPaymentProductEnrollment,
  createProgram,
  deleteMerchantExperience,
  deleteMerchantProgramParticipationByID,
  deletePartnerProgramParticipation,
  deletePaymentProductEnrollment,
  getCreatePartnerProgramParticipationMutationOptions,
  getCreatePaymentProductEnrollmentMutationOptions,
  getCreateProgramMutationOptions,
  getDeleteMerchantExperienceMutationOptions,
  getDeleteMerchantProgramParticipationByIDMutationOptions,
  getDeletePartnerProgramParticipationMutationOptions,
  getDeletePaymentProductEnrollmentMutationOptions,
  getFundingConfiguration,
  getGetFundingConfigurationQueryKey,
  getGetFundingConfigurationQueryOptions,
  getGetFundingConfigurationSuspenseQueryOptions,
  getGetMerchantEnrollmentQueryKey,
  getGetMerchantEnrollmentQueryOptions,
  getGetMerchantEnrollmentSuspenseQueryOptions,
  getGetMerchantExperienceByIDQueryKey,
  getGetMerchantExperienceByIDQueryOptions,
  getGetMerchantExperienceByIDSuspenseQueryOptions,
  getGetMerchantProgramParticipationByIDQueryKey,
  getGetMerchantProgramParticipationByIDQueryOptions,
  getGetMerchantProgramParticipationByIDSuspenseQueryOptions,
  getGetMerchantProgramParticipationQueryKey,
  getGetMerchantProgramParticipationQueryOptions,
  getGetMerchantProgramParticipationSuspenseQueryOptions,
  getGetMerchantProgramValuesQueryKey,
  getGetMerchantProgramValuesQueryOptions,
  getGetMerchantProgramValuesSuspenseQueryOptions,
  getGetPartnerProgramParticipationQueryKey,
  getGetPartnerProgramParticipationQueryOptions,
  getGetPartnerProgramParticipationSuspenseQueryOptions,
  getGetPartnerProgramValuesQueryKey,
  getGetPartnerProgramValuesQueryOptions,
  getGetPartnerProgramValuesSuspenseQueryOptions,
  getGetPaymentProductAggregationQueryKey,
  getGetPaymentProductAggregationQueryOptions,
  getGetPaymentProductAggregationSuspenseQueryOptions,
  getGetPaymentProductByIDQueryKey,
  getGetPaymentProductByIDQueryOptions,
  getGetPaymentProductByIDSuspenseQueryOptions,
  getGetPaymentProductConfigurationQueryKey,
  getGetPaymentProductConfigurationQueryOptions,
  getGetPaymentProductConfigurationSuspenseQueryOptions,
  getGetPaymentProductsFilterQueryKey,
  getGetPaymentProductsFilterQueryOptions,
  getGetPaymentProductsFilterSuspenseQueryOptions,
  getGetPaymentProductsForMerchantAndProgramQueryKey,
  getGetPaymentProductsForMerchantAndProgramQueryOptions,
  getGetPaymentProductsForMerchantAndProgramSuspenseQueryOptions,
  getGetPaymentProductsForProgramQueryKey,
  getGetPaymentProductsForProgramQueryOptions,
  getGetPaymentProductsForProgramSuspenseQueryOptions,
  getGetProgramByIDQueryKey,
  getGetProgramByIDQueryOptions,
  getGetProgramByIDSuspenseQueryOptions,
  getGetProgramsForTenantQueryKey,
  getGetProgramsForTenantQueryOptions,
  getGetProgramsForTenantSuspenseQueryOptions,
  getListEnrollmentSummariesQueryKey,
  getListEnrollmentSummariesQueryOptions,
  getListEnrollmentSummariesSuspenseQueryOptions,
  getListExperiencesQueryKey,
  getListExperiencesQueryOptions,
  getListExperiencesSuspenseQueryOptions,
  getListMerchantExperienceQueryKey,
  getListMerchantExperienceQueryOptions,
  getListMerchantExperienceSuspenseQueryOptions,
  getListMerchantPaymentProductEnrollmentQueryKey,
  getListMerchantPaymentProductEnrollmentQueryOptions,
  getListMerchantPaymentProductEnrollmentSuspenseQueryOptions,
  getListPartnerProgramParticipationQueryKey,
  getListPartnerProgramParticipationQueryOptions,
  getListPartnerProgramParticipationSuspenseQueryOptions,
  getListPaymentProductEnrollmentQueryKey,
  getListPaymentProductEnrollmentQueryOptions,
  getListPaymentProductEnrollmentSuspenseQueryOptions,
  getMerchantEnrollment,
  getMerchantExperienceByID,
  getMerchantProgramParticipation,
  getMerchantProgramParticipationByID,
  getMerchantProgramValues,
  getPartnerProgramParticipation,
  getPartnerProgramValues,
  getPatchPaymentProductEnrollmentMutationOptions,
  getPaymentProductAggregation,
  getPaymentProductByID,
  getPaymentProductConfiguration,
  getPaymentProductsFilter,
  getPaymentProductsForMerchantAndProgram,
  getPaymentProductsForProgram,
  getProgramByID,
  getProgramsForTenant,
  getUpdateFundingConfigurationMutationOptions,
  getUpdateMerchantProgramValuesMutationOptions,
  getUpdateUICustomizationsMutationOptions,
  listEnrollmentSummaries,
  listExperiences,
  listMerchantExperience,
  listMerchantPaymentProductEnrollment,
  listPartnerProgramParticipation,
  listPaymentProductEnrollment,
  patchPaymentProductEnrollment,
  updateFundingConfiguration,
  updateMerchantProgramValues,
  updateUICustomizations,
  useCreatePartnerProgramParticipation,
  useCreatePaymentProductEnrollment,
  useCreateProgram,
  useDeleteMerchantExperience,
  useDeleteMerchantProgramParticipationByID,
  useDeletePartnerProgramParticipation,
  useDeletePaymentProductEnrollment,
  useGetFundingConfiguration,
  useGetFundingConfigurationSuspense,
  useGetMerchantEnrollment,
  useGetMerchantEnrollmentSuspense,
  useGetMerchantExperienceByID,
  useGetMerchantExperienceByIDSuspense,
  useGetMerchantProgramParticipation,
  useGetMerchantProgramParticipationByID,
  useGetMerchantProgramParticipationByIDSuspense,
  useGetMerchantProgramParticipationSuspense,
  useGetMerchantProgramValues,
  useGetMerchantProgramValuesSuspense,
  useGetPartnerProgramParticipation,
  useGetPartnerProgramParticipationSuspense,
  useGetPartnerProgramValues,
  useGetPartnerProgramValuesSuspense,
  useGetPaymentProductAggregation,
  useGetPaymentProductAggregationSuspense,
  useGetPaymentProductByID,
  useGetPaymentProductByIDSuspense,
  useGetPaymentProductConfiguration,
  useGetPaymentProductConfigurationSuspense,
  useGetPaymentProductsFilter,
  useGetPaymentProductsFilterSuspense,
  useGetPaymentProductsForMerchantAndProgram,
  useGetPaymentProductsForMerchantAndProgramSuspense,
  useGetPaymentProductsForProgram,
  useGetPaymentProductsForProgramSuspense,
  useGetProgramByID,
  useGetProgramByIDSuspense,
  useGetProgramsForTenant,
  useGetProgramsForTenantSuspense,
  useListEnrollmentSummaries,
  useListEnrollmentSummariesSuspense,
  useListExperiences,
  useListExperiencesSuspense,
  useListMerchantExperience,
  useListMerchantExperienceSuspense,
  useListMerchantPaymentProductEnrollment,
  useListMerchantPaymentProductEnrollmentSuspense,
  useListPartnerProgramParticipation,
  useListPartnerProgramParticipationSuspense,
  useListPaymentProductEnrollment,
  useListPaymentProductEnrollmentSuspense,
  usePatchPaymentProductEnrollment,
  useUpdateFundingConfiguration,
  useUpdateMerchantProgramValues,
  useUpdateUICustomizations
};
//# sourceMappingURL=index.mjs.map